import { mutations as TYPES } from "./types";
import { FETCH } from "@/utils/list.js";

const mutations = {
  [TYPES.TUTORIAL_FETCH_PLAYLIST](state, { id, items }) {
    // Create empty playlist if it's not exist
    if (!state.playlist.hasOwnProperty(id)) {
      state.playlist.___count___++;
      state.playlist[id] = [];
    }

    let comparer = (obj, item) => {
      return obj.id === item.id;
    };
    FETCH(state.playlist[id], items, comparer, null);
  },
  [TYPES.TUTORIAL_FETCH_PLAYLISTS](state, list) {
    let comparer = (obj, item) => {
      return obj.id === item.id;
    };
    FETCH(state.topic.list, list, comparer, null);
  },
  [TYPES.TUTORIAL_SET_TOPIC](state, id) {
    state.topicID = id;
  }
};

export default mutations;
